import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyOrganisationComponent } from './my-organisation.component';
import { EditCompanyQuotaComponent } from './components/edit-company/edit-company-quota.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from 'ng2-translate';
import { MaterialModule } from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    TranslateModule.forRoot()
  ],
  declarations: [MyOrganisationComponent, EditCompanyQuotaComponent],
  exports: [MyOrganisationComponent],
  entryComponents: [
    EditCompanyQuotaComponent
  ]
})
export class MyOrganisationModule { }



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/my-organisation/my-organisation.module.ts